import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AdmissionCycles from "Admissions/routes/admissionUnit/routes/adminPortal/routes/admissionCycles";
import StagesAndStatuses from "Admissions/routes/admissionUnit/routes/adminPortal/routes/stagesAndStatuses";
import Checklists from "Admissions/routes/admissionUnit/routes/adminPortal/routes/checklists";
import FormAndFieldSettings from "Admissions/routes/admissionUnit/routes/adminPortal/routes/formAndFieldSettings";
import ApplicantPipeline from "Admissions/routes/admissionUnit/routes/adminPortal/routes/applicantPipeline";

// Mounted at /admissions/:unitId/adminPortal. Sections render inside the
// pathless AdminPortalShell layout (sidebar + content). The
// `admissionCycles/:cycleId/edit` deep-link is now a child of AdmissionCycles
// itself — the listing stays mounted and renders the edit overlay on top.
//
// Bare /adminPortal redirects to /adminPortal/admissionCycles.
export default store => ({
  path: "adminPortal",
  indexRoute: {
    onEnter: (nextState, replace) =>
      replace(
        `/admissions/${nextState.params.unitId}/adminPortal/admissionCycles`
      ),
  },
  childRoutes: [
    {
      component: withAsyncRouteLoading(() =>
        import(
          /* webpackChunkName: "admissions-admin-portal" */ "Admissions/features/AdminPortal/components/AdminPortalShell"
        ).then(m => m.default)
      ),
      childRoutes: [
        AdmissionCycles(store),
        StagesAndStatuses(store),
        ApplicantPipeline(store),
        Checklists(store),
        FormAndFieldSettings(store),
      ],
    },
  ],
});
